/* Only a click loads the local conversation runtime. No inference API. */
(function(){
 'use strict';
 const host=document.querySelector('wjg-assistant[data-runtime]');if(!host||host.dataset.loaderBound)return;host.dataset.loaderBound='true';
 const trigger=host.nextElementSibling;if(!trigger?.classList.contains('wjg-fallback'))return;
 let loading=false,failed=false;
 trigger.addEventListener('click',event=>{
  if(failed)return;
  if(host.hasAttribute('data-wjg-ready')){event.preventDefault();host.toggle?.(true);return;}
  event.preventDefault();host.dataset.openRequested='true';if(loading)return;loading=true;trigger.setAttribute('aria-busy','true');
  const url=new URL(host.dataset.runtime,location.href),styleURL=new URL(host.dataset.style,location.href);
  const allowed=u=>(u.protocol==='https:'||u.origin===location.origin&&u.protocol==='http:')&&(u.origin===location.origin||u.hostname==='cdn.shopify.com');
  if(!allowed(url)||!allowed(styleURL)){failed=true;trigger.removeAttribute('aria-busy');return;}
  const fail=()=>{if(!host.hasAttribute('data-wjg-ready')){failed=true;loading=false;trigger.removeAttribute('aria-busy');trigger.title='Contact';}};
  fetch(styleURL.href,{credentials:'same-origin'}).then(r=>{if(!r.ok)throw Error('Guide style');return r.text();}).then(css=>{
   if(!css.includes(':host'))throw Error('Guide style');window.WJGAssistantStyle=css;
   const script=document.createElement('script');script.src=url.href;script.async=true;script.onerror=fail;script.onload=()=>{trigger.removeAttribute('aria-busy');if(!host.hasAttribute('data-wjg-ready'))fail();};document.head.append(script);
  }).catch(fail);
  setTimeout(fail,15000);
 });
})();

/* Resolve store help links independently of opening the chat. */
(function(){
 const suffixes={'#wjg-size':'measurements','#wjg-closure':'closure','#wjg-care':'materiales'};
 function navigate(){
  const hash=location.hash,suffix=suffixes[hash];if(!suffix)return;
  const pdp=document.querySelector('wj-pdp-v98');if(!pdp)return;
  customElements.whenDefined('wj-pdp-v98').then(()=>{
   if(location.hash!==hash)return;
   const detail=pdp.querySelector('details[id$="-'+suffix+'"]');if(!detail)return;
   if(typeof pdp.setAccordion==='function')pdp.setAccordion(detail,true,false);else detail.open=true;
   requestAnimationFrame(()=>{detail.scrollIntoView({behavior:'auto',block:'start'});detail.querySelector('summary')?.focus({preventScroll:true});});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',navigate,{once:true});else navigate();
 window.addEventListener('hashchange',navigate);
})();
